// Footer.js
import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer( { scrollToAbout , scrollToService , scrollToProject , scrollToContact }) {

  const btnclick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
}

  return (
    <footer className="bg-gray-800 text-gray-300 py-4">
    <div className="container mx-auto flex flex-col lg:items-center lg:space-y-4">
      <div className="flex flex-col items-center lg:flex-row lg:space-x-4">
        <Link onClick={btnclick} className="text-gray-300 hover:text-white">Home</Link>
        <Link  onClick={scrollToAbout}  className="text-gray-300 hover:text-white">About</Link>
        <Link onClick={scrollToService} className="text-gray-300 hover:text-white">Services</Link>
        <Link onClick={scrollToProject} className="text-gray-300 hover:text-white">Projects</Link>
        <Link onClick={scrollToContact} className="text-gray-300 hover:text-white">Contact</Link>
      </div>
      <div className="text-sm mt-4 lg:mt-0 lg:self-center">
        © {new Date().getFullYear()} Portfolio By Mukund. All rights reserved.
      </div>
    </div>
  </footer>
  
  );
}
